import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-lg">
            <div className="relative rounded-2xl overflow-hidden border border-background-300/40 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20Chinese%20drama%20streaming%20app%20interface%2C%20modern%20clean%20UI%20with%20drama%20posters%20grid%2C%20dark%20theme%20with%20warm%20accent%20colors%2C%20elegant%20mobile%20app%20design%2C%20professional%20product%20photography%20with%20soft%20shadows&width=600&height=800&seq=app-mockup-01&orientation=portrait"
                alt="爱豆影视 - 移动端追剧体验"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              {appData.desc}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-8">
              {appData.features.map((feat) => (
                <span
                  key={feat}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-foreground-700 bg-background-100 border border-background-200/60 rounded-full whitespace-nowrap"
                >
                  <i className="ri-check-line text-primary-400"></i>
                  {feat}
                </span>
              ))}
            </div>

            <a
              href="#media"
              className="inline-flex items-center gap-2 px-8 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-smartphone-line"></i>
              立即体验
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}